import React, { Fragment } from 'react';
import { ThinArrow } from './Decorations';
const photos = [{
  url: 'https://cdn.magicpatterns.com/uploads/oLH3zyTCYZyLwiCqbD11kK/image_(5).png',
  label: '1970s',
  alt: 'Mladi Dani s kitaro'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/44GUgBHmwY1RDpd3f1ehM1/image_(6).png',
  label: '1978',
  alt: 'Dani v obleki'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/jLAW6i6fotXktQpsdmqdVe/image_(4).png',
  label: 'danes',
  alt: 'Dani danes v rumenem puloverju'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/4KV5HTM5cMH7JjuJxWc5cd/image_(3).png',
  label: 'bolj star bolj nor',
  alt: 'Dani na motorju s čelado'
}];
export function PhotoTimeline() {
  return <div className="w-full max-w-5xl mx-auto mt-12 mb-16 px-4" data-id="element-102">
      {/* Desktop Layout */}
      <div className="hidden md:flex flex-col items-center" data-id="element-103">
        <div className="flex items-center justify-center gap-4 lg:gap-6 mb-6" data-id="element-104">
          {photos.map((photo, index) => <div key={index} className="w-40 h-56 lg:w-48 lg:h-64 overflow-hidden rounded-sm shadow-md border-4 border-white transform transition-transform duration-500 hover:-translate-y-2 bg-white" data-id="element-105">
              <img src={photo.url} alt={photo.alt} className="w-full h-full object-cover filter sepia-[0.15] contrast-[0.95]" data-id="element-106" />
            </div>)}
        </div>
        <div className="flex items-center justify-center" data-id="element-107">
          {photos.map((photo, index) => <Fragment key={index} data-id="element-108">
              <span className="font-serif italic text-olive/90 text-xl px-2" data-id="element-109">
                {photo.label}
              </span>
              {index < photos.length - 1 && <ThinArrow data-id="element-110" />}
            </Fragment>)}
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="flex md:hidden flex-col items-center gap-8" data-id="element-111">
        {photos.map((photo, index) => <div key={index} className="flex flex-col items-center" data-id="element-112">
            <div className="w-56 h-72 overflow-hidden rounded-sm shadow-md border-4 border-white bg-white mb-4" data-id="element-113">
              <img src={photo.url} alt={photo.alt} className="w-full h-full object-cover filter sepia-[0.15] contrast-[0.95]" data-id="element-114" />
            </div>
            <span className="font-serif italic text-olive/90 text-xl mb-2" data-id="element-115">
              {photo.label}
            </span>
            {index < photos.length - 1 && <div className="h-12 w-px bg-olive/30 relative mt-2" data-id="element-116">
                <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 border-b border-r border-olive/40 rotate-45" data-id="element-117"></div>
              </div>}
          </div>)}
      </div>
    </div>;
}